import {
    FETCH_CAMPAIGN_REPORT,
    FETCH_CAMPAIGN_USAGES_REPORT,
    FETCH_MEMBER_PURCHASE_HISTORY,
} from '../types';
import api from '../api';

export const fetchCampaignReport = (data) => {
    return {
        type: FETCH_CAMPAIGN_REPORT,
        payload: api.reports.campaign.general(data),
    };
};

export const fetchCampaignUsagesReport = (data) => {
    return {
        type: FETCH_CAMPAIGN_USAGES_REPORT,
        payload: api.reports.campaign.usages(data),
    };
};

export const fetchMemberPurchaseHistory = (data) => {
    return {
        type: FETCH_MEMBER_PURCHASE_HISTORY,
        payload: api.reports.member.history(data),
    };
};
